<template>
  <div class="offcn_live_statuspage">
    <div class="status_cannotfind">
      <img src="static/img/404.png" alt="">
      <p>啊哦...找不到这个页面</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cannotfindpage'
}
</script>

<style scoped  lang="scss">
  .offcn_live_statuspage{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #ffffff;
    z-index: 5;
  }
  .status_cannotfind{
    width: 100%;
    height: 100%;
    background: #ffffff;
  img{

    display: block;
    width: 330px;
    margin: 0 auto;
    margin-top: 250px;
  }
  p{
    text-align: center;
    font-size: 28px;
    color: #333333;
    margin-top: 40px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/404.vue